import React from "react";
import { AppProvider } from "@shopify/polaris";
import { Provider } from "react-redux";
import store from "./store";

import BaseRoute from "./BaseRoute";
import enTranslations from "@shopify/polaris/locales/en.json";
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <Provider store={store}>
      <AppProvider i18n={enTranslations}>
        <BaseRoute />
      </AppProvider>
    </Provider>
  );
}

export default App;
